import React, { useState, useEffect } from "react";
import axios from "axios";
import '../assets/styles/Dashboard.css';
import Francy from '../assets/Francias/francias.svg'
import Direct from '../assets/Francias/directclient.svg'
import Ticket from '../assets/Francias/Ticket.svg';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faIndianRupee } from "@fortawesome/free-solid-svg-icons";
import SalesReport from "./salegrap.js";
import config from '../config.js';
import Franchandclientchart from "./franchandclientchart.js";


function Dashboard() {
  const [count, setCount] = useState(0);
  const [clientcount, setClientcount] = useState(0);
  const [franchisenotaprove, setFranchiseaprove] = useState(0);
  const [pendingCounts, setPendingCounts] = useState({ franchisePendingCount: 0, clientPendingCount: 0,});
  const [totalAmounts, setTotalAmounts] = useState([]);
  const [totalAmountfranch, setTotalAmountfranch] = useState(0);

  useEffect(() => {
    const fetchFranchiseCount = async () => {
      try {
        const response = await axios.get(`${config.apiBaseUrl}/admin/getfranchcount`);
        setCount(response.data.count); 
      } catch (err) {
        console.error("Error fetching franchise count:", err);
      }
    };
    fetchFranchiseCount();
  }, []);
  useEffect(() => {
    const fetchclientCount = async () => {
      try {
        const response = await axios.get(`${config.apiBaseUrl}/admin/getclientcount`);
        setClientcount(response.data.count); 
      } catch (err) {
        console.error("Error fetching client count:", err);
      }
    };
    fetchclientCount();
  }, []);
  
  useEffect(() => {
  const fetchFranchiseCount = async () => {
    try {
      const response = await axios.get(`${config.apiBaseUrl}/admin/cannotapprove`);
      setFranchiseaprove(response.data.not_approve); 
    } catch (err) {
      console.error("Error fetching NOT apporove count:", err);
     
    }
  };
    fetchFranchiseCount(); 
  }, []);

  useEffect(() => {
    axios
      .get(`${config.apiBaseUrl}/admin/pendingreq`) 
      .then((response) => {
        setPendingCounts(response.data);
      })
      .catch((error) => {
        console("Failed to fetch data",error);
      });
  }, []);

  useEffect(() => {
    axios.get(`${config.apiBaseUrl}/admin/total_amountclient`)
      .then(response => {
        setTotalAmounts(response.data);  
      })
      .catch(err => {
        console.log("Failed to fetch data",err);
      });
  }, []);

  useEffect(() => { 
    const fetchTotalAmount = async () => {
      try {
        const response = await axios.get(`${config.apiBaseUrl}/admin/total_amountfranchise`);
        setTotalAmountfranch(response.data.total_amountfranch ); 
      } catch (err) {
        console.error('Error fetching data:', err);
        setTotalAmountfranch(0); 
      }
    };
    fetchTotalAmount();
  }, [])
  return (
    <div className="Dashboard-cm">
      <div className="row">
        <div className="col-lg-6 col-md-12 col-12 col-12  mt-2">
          <div className="row">
            <div className="col-sm-6 mt-1">
              <div className="overview-container  card ">
                <div className="d-flex">
                  <img src={Francy} alt="francy" className="overview-img" />
                  <h6 className="overview-text mt-2">Franchise</h6>
                </div>
                <div className="mt-4 ms-2">
                  <h1 className="Dashboardcount text-center">{count} </h1>
                </div>
              </div>
            </div>
            <div className="col-sm-6 mt-1">
              <div className="overview-container card">
                <div className="d-flex">
                  <img src={Direct} alt="francy" className="overview-img" />
                  <h6 className="overview-text mt-2 ellipsis">Direct Client</h6>
                </div>
                <div className="mt-4 ms-2">
                  <h1 className="Dashboardcount text-center"> {clientcount} </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-12 col-12 order-lg-2 mt-2">
          <div className="row">
            <div className="col-sm-12 mt-1">
              <div className="overview-container">
                <div className="d-flex">
                  <img src={Ticket} alt="francy" className="overview-img" />
                  <h1 className="overview-text mt-2">Request summary</h1>
                </div>
                <div className="row d-flex justify-content-center  mt-4">
                  <div className="col-4">
                    <h1 className="Dashboardcount text-center">{franchisenotaprove} </h1>
                    <p className="text-center">Registration request</p>
                  </div>
                  <div className="col-4">
                    <h1 className="Dashboardcount text-center">{pendingCounts.franchisePendingCount}</h1>
                    <p className="text-center">License upgrade</p>
                  </div>
                  <div className="col-4">
                    <h1 className="Dashboardcount text-center">{pendingCounts.clientPendingCount}</h1>
                    <p className="text-center">Plan update</p>
                  </div> 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row mt-2">
      <div className="col-lg-4  col-md-12 col-sm-12 mt-2">
      <div className="overview-containers">
        <div className="header">
          <h6 className="chart-title">Revenue</h6>
        </div>
        <div className="d-flex ms-4  mt-3">
                  <img src={Francy} alt="francy" className="overview-imgs" />
                  <h6 className="overview-text mt-2">Franchise</h6>
                </div>
        <h4 className="Dashboardcount p-3 ms-2 mt-3">
          <FontAwesomeIcon className="dashrupeeicon" icon={faIndianRupee} />
          &nbsp;{totalAmountfranch}
        </h4>
        <p className="description p-3">
          Only franchise payment revenue
        </p>
        <div className="percentage-container">
          <span className="percentage">▲ 0%</span> <span>this month</span>
        </div>
      </div>
    </div><div className="col-lg-4  col-md-12 col-sm-12 mt-2">
      <div className="overview-containers">
        <div className="header">
          <h6 className="chart-title">Revenue</h6>
        </div>
        <div className="d-flex ms-4 mt-3">
                  <img src={Direct} alt="francy" className="overview-imgs" />
                  <h6 className="overview-text mt-2 ellipsis">Direct Client</h6>
                </div>
                <h4 className="Dashboardcount p-3 ms-2 mt-3">
      <FontAwesomeIcon className="dashrupeeicon" icon={faIndianRupee} />
      &nbsp;
      {totalAmounts.length > 0 ? totalAmounts[0].total_amount : "Loading..."}
    </h4>
        <p className="description p-3">
          Only direct customers payment  revenue
        </p>
        <div className="percentage-container">
          <span className="percentage">▲ 0%</span> <span>this month</span>
        </div>
      </div>
    </div>
        <div className="col-lg-4  col-md-12 col-sm-12 mt-2">
          <div className="overview-containers ">
            <h6 className="chart-title">Total license assigned</h6>
           
            <Franchandclientchart/>
            <div className="row d-flex justify-content-end ">
            <div className="legend">
              <div className="franchise text-end">
                <span className="franchise-dot"></span>
                Franchise
              </div>
              <div className="direct-client">
                <span className="client-dot"></span>
                Direct Client
              </div>
            </div>
            </div>
          </div>
        </div>
        <div className="col-lg-12  col-md-12 col-12 mt-3">
          <div className="overview-containers">
            <SalesReport/>
          </div>
        </div>
      </div>  
    </div>
  );
}

export default Dashboard;
